import { render } from "./ProbateSidebar.vue?vue&type=template&id=9d7c5678&ts=true"
import script from "./ProbateSidebar.vue?vue&type=script&lang=ts"
export * from "./ProbateSidebar.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__